"use strict";
/**
 * @file Defines the $dyn.flyout.flyoutManager namespace
 * @copyright 2016 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    /** Namespace that contains all the flyout related functions, classes, and objects */
    var flyout;
    (function (flyout_1) {
        var FlyoutManager = /** @class */ (function () {
            function FlyoutManager() {
                var _this = this;
                /**
                 * Adds a flyout to the flyout stack. Registers event listeners if this is the
                 * first flyout to be added.
                 * @param flyout The flyout registration object.
                 */
                // tslint:disable-next-line:no-shadowed-variable
                this.addFlyout = function (flyout) {
                    if (_this.flyoutStack.length === 0) {
                        document.body.addEventListener("click", $dyn.flyout.flyoutManager.bodyClickHandler, true);
                        document.body.addEventListener("mousedown", $dyn.flyout.flyoutManager.mouseDownHandler, true);
                        document.body.addEventListener("keydown", $dyn.util.flyout.keyDownHandler, true);
                    }
                    _this.flyoutStack.push(flyout);
                };
                /**
                 * Gets the flyout elements for all flyouts given the parent form id.
                 * @param parentFormId The id of the form to find.
                 * @returns Array of flyout elements.
                 */
                this.getAllFlyoutElementsByParentFormId = function (parentFormId) {
                    var foundFlyouts = _this.findAllFlyoutsByParentFormId(parentFormId);
                    // tslint:disable-next-line:no-shadowed-variable
                    return foundFlyouts.map(function (flyout) {
                        return $dyn.value(flyout.flyout)[0];
                    });
                };
                /**
                 * Gets the flyout elements for all flyouts for the given form id.
                 * @param formId The id of the form to find.
                 * @returns Array of flyout elements.
                 */
                this.getAllFlyoutElementsByFormId = function (formId) {
                    var foundFlyouts = _this.findAllFlyoutsByFormId(formId);
                    // tslint:disable-next-line:no-shadowed-variable
                    return foundFlyouts.map(function (flyout) {
                        return $dyn.value(flyout.flyout)[0];
                    });
                };
                /**
                 * Checks if there are any flyouts on the stack.
                 * @see $dyn.flyout.flyoutManager.getFlyoutCount
                 * @returns Flag indicating if there are any open flyouts.
                 */
                this.areAnyFlyoutsOpen = function () {
                    return _this.flyoutStack.length > 0;
                };
                /**
                 * Gets the flyout context of the top most flyout a given form Id.
                 * @param formId The id of the form to find.
                 * @returns Flyout context. Returns null if no flyout found.
                 */
                this.getFlyoutContextByFormId = function (formId) {
                    var flyoutElements = _this.getAllFlyoutElementsByFormId(formId);
                    if (flyoutElements.length > 0) {
                        var topMatch = flyoutElements[flyoutElements.length - 1];
                        return $dyn.context(topMatch);
                    }
                    return null;
                };
                /**
                 * Gets the number of flyouts in the stack.
                 * @returns The number of flyouts.
                 */
                this.getFlyoutCount = function () {
                    return _this.flyoutStack.length;
                };
                /**
                 * Gets the flyout registration object for the top most flyout.
                 * @returns Flyout registration object.
                 */
                this.getTopFlyout = function () {
                    return _this.flyoutStack[_this.flyoutStack.length - 1];
                };
                this.tryTakeNavigationFocus = function (formToTakeNavigationFocus) {
                    var topFlyout = $dyn.flyout.flyoutManager.getTopFlyout();
                    if (topFlyout) {
                        // Consider the scenario that the top most flyout is rooted by this instance and the flyout requires special focus management. Typically
                        // this would mean that the flyout itself is not a form.
                        var $flyoutElement = $dyn.value(topFlyout.flyout);
                        if ($flyoutElement && $flyoutElement.length) {
                            var flyoutElement = $flyoutElement[0];
                            var flyoutContext = $dyn.context(flyoutElement);
                            // TODO: instanceof $dyn.controls.ProtoForm -- Phantomjs fails on instanceof, while Chrome et. al. Investigate.
                            if (flyoutContext && flyoutContext.__protoForm &&
                                $dyn.util.isRootedBy(formToTakeNavigationFocus, flyoutContext)) {
                                // The flyout is rooted by this instance. Give focus to the element that was last focused on the flyout instead of
                                // giving focus to this form itself.
                                return flyoutContext.takeNavigationFocus();
                            }
                        }
                    }
                    return false;
                };
                /**
                 * Attempts to find the flyout container of the provided element.
                 * @param candidateElement The element for which to find the containing flyout, if any.
                 * @returns A jQuery object representing the found flyout.
                 */
                this.findFlyoutContainer = function (candidateElement) {
                    return $(candidateElement).closest(".sysPopup");
                };
                /**
                 * Determines whether or not the provided candidateChildElement is contained by the
                 * flyout hierarchy beginning with the provided flyoutElement.
                 * @param flyoutElement Flyout representing the root of the flyout hierarchy.
                 * @param candidateChildElement The element that may belong to the hierarchy.
                 * @returns True if the candidateChildElement is contained by the flyoutElement hierarchy; otherwise, false.
                 */
                this.isContainedByFlyoutHierarchy = function (flyoutElement, candidateChildElement) {
                    var isContained = false;
                    var $closestSysPopup = $dyn.flyout.flyoutManager.findFlyoutContainer(candidateChildElement);
                    if ($closestSysPopup.length === 1) {
                        var closestSysPopupElement = $closestSysPopup[0];
                        var closestPopupContext = $dyn.context(closestSysPopupElement);
                        var flyoutContext = $dyn.context(flyoutElement);
                        if (closestPopupContext === flyoutContext || closestPopupContext.Root === flyoutContext) {
                            isContained = true;
                        }
                        else if (closestPopupContext.Root && closestPopupContext.Root.element) {
                            isContained = _this.isContainedByFlyoutHierarchy(flyoutElement, closestPopupContext.Root.element);
                        }
                    }
                    return isContained;
                };
                /**
                 * Removes all the flyouts from the stack in order.
                 * @param mouseClickEvent The event object for the mouse click.
                 * @returns jQuery promise.
                 */
                this.removeAllFlyoutsAsync = function (mouseClickEvent) {
                    var iteratorArray = _this.flyoutStack.map(function () {
                        return "";
                    });
                    var isClickInTopFlyout = function (mouseEvent) {
                        if (!mouseEvent) {
                            return false;
                        }
                        var mouseClickInfo = _this.getMouseClickInfo(mouseEvent);
                        var topFlyout = $dyn.flyout.flyoutManager.getTopFlyout();
                        if (!topFlyout || !$dyn.value(topFlyout.showFlyout)) {
                            return false;
                        }
                        var flyoutjQueryElement = $dyn.value(topFlyout.flyout);
                        return $dyn.util.flyout.IsClickInFlyout(mouseClickInfo.clickTarget, flyoutjQueryElement, mouseClickInfo.clickX, mouseClickInfo.clickY);
                    };
                    var isClickInTopLevelFlyout = isClickInTopFlyout(mouseClickEvent);
                    var overallPromise = iteratorArray.reduce(function (promise) {
                        return promise.done(function () {
                            return _this.removeTopFlyoutAsync(mouseClickEvent, isClickInTopLevelFlyout);
                        });
                    }, $.when());
                    return overallPromise;
                };
                /**
                 * Removes a specific flyout from the stack.
                 * @param flyout The flyout registration object of the flyout to remove.
                 */
                // tslint:disable-next-line:no-shadowed-variable
                this.removeFlyout = function (flyout) {
                    var indexOfFlyout = _this.flyoutStack.lastIndexOf(flyout);
                    if (indexOfFlyout >= 0) {
                        _this.flyoutStack.splice(indexOfFlyout, 1);
                    }
                    if (flyout.handle) {
                        $(document.body).off(flyout.handle);
                    }
                    if (flyout.tabbingHandlerDispose) {
                        flyout.tabbingHandlerDispose();
                    }
                    if (_this.flyoutStack.length === 0) {
                        $(document.body).off(".flyout");
                        document.body.removeEventListener("click", $dyn.flyout.flyoutManager.bodyClickHandler, true);
                        document.body.removeEventListener("mousedown", $dyn.flyout.flyoutManager.mouseDownHandler, true);
                        document.body.removeEventListener("keydown", $dyn.util.flyout.keyDownHandler, true);
                        if ($dyn.util.flyout.flyoutTimer) {
                            window.clearInterval($dyn.util.flyout.flyoutTimer);
                            $dyn.util.flyout.flyoutTimer = undefined;
                        }
                    }
                };
                /**
                 * Removes a specific flyout from the stack by its ID.
                 * @param targetElementId The flyout element id of the flyout to remove.
                 */
                this.removeFlyoutByElementId = function (targetElementId) {
                    // tslint:disable-next-line:no-shadowed-variable
                    var flyoutsWithMatchingElementId = _this.flyoutStack.filter(function (flyout) {
                        var flyoutElement = $dyn.value(flyout.flyout)[0];
                        var elementId = flyoutElement.getAttribute("id");
                        return elementId === targetElementId;
                    });
                    if (flyoutsWithMatchingElementId.length > 0) {
                        var topMatch = flyoutsWithMatchingElementId[flyoutsWithMatchingElementId.length - 1];
                        _this.removeFlyout(topMatch);
                    }
                };
                /**
                 * Removes the top most flyout from the stack.
                 * @param mouseClickEvent The event object for the mouse click
                 * @param isClickInTopLevelFlyout A flag indicating if the click was within the flyout at the top of the stack.
                 * @returns jQuery promise.
                 */
                this.removeTopFlyoutAsync = function (mouseClickEvent, isClickInTopLevelFlyout) {
                    var deferred = $.Deferred();
                    if (_this.flyoutStack.length === 0) {
                        deferred.reject("No open flyouts");
                        return deferred.promise();
                    }
                    // We don't want to pop it yet because it may not successfully close.
                    var topFlyout = _this.flyoutStack[_this.flyoutStack.length - 1];
                    if (mouseClickEvent) {
                        var mouseClickInfo = _this.getMouseClickInfo(mouseClickEvent);
                        var flyoutjQueryElement = $dyn.value(topFlyout.flyout);
                        var flyoutElement = flyoutjQueryElement[0];
                        var shown = $dyn.value(topFlyout.showFlyout);
                        var isClickInFlyout = shown && $dyn.util.flyout.IsClickInFlyout(mouseClickInfo.clickTarget, flyoutjQueryElement, mouseClickInfo.clickX, mouseClickInfo.clickY);
                        var shouldCloseFlyout = topFlyout.clickSubscriber({
                            clickInsideTopFlyout: isClickInTopLevelFlyout || false,
                            clickTarget: mouseClickInfo.clickTarget,
                            clickX: mouseClickInfo.clickX,
                            clickY: mouseClickInfo.clickY,
                            closeCallback: undefined,
                            flyoutElement: flyoutjQueryElement,
                            isClickInsideThisFlyout: isClickInFlyout,
                            isRightClick: mouseClickInfo.isRightClick,
                        });
                        if (!shouldCloseFlyout) {
                            deferred.reject("Flyout does not want to close");
                            return deferred.promise();
                        }
                        if (!isClickInFlyout && !topFlyout.highlyResponsive) {
                            // Note: Don't stop the click if the flyout is "highly responsive" as it's guaranteed to close. This allows a popup
                            // to be opened immediately via a mouse click while an existing popup is opened.
                            if (flyoutElement.classList &&
                                !flyoutElement.classList.contains("allowFlyoutClickPropagation") &&
                                mouseClickInfo.clickTarget &&
                                mouseClickInfo.clickTarget.classList &&
                                !mouseClickInfo.clickTarget.classList.contains("allowFlyoutClickPropagation")) {
                                mouseClickEvent.stopImmediatePropagation();
                                mouseClickEvent.preventDefault();
                                $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent mouse click event from bubbling to other flyouts.");
                            }
                        }
                    }
                    topFlyout.requestClose()
                        .done(function () {
                        _this.removeFlyout(topFlyout);
                        deferred.resolve();
                    })
                        .fail(function (reason) {
                        deferred.reject(reason);
                    });
                    return deferred.promise();
                };
                /**
                 * Repositions all flyouts.
                 */
                this.repositionAllFlyouts = function () {
                    for (var i = _this.flyoutStack.length - 1; i >= 0; i--) {
                        var flyoutRegistration = $dyn.value(_this.flyoutStack[i]);
                        var flyoutOptions = flyoutRegistration.options;
                        var flyoutAnchor = $dyn.applyFunction(flyoutOptions.getAnchor) || flyoutOptions.of;
                        var flyoutTarget = flyoutRegistration.target;
                        if (!flyoutTarget && flyoutRegistration.getTarget) {
                            flyoutTarget = flyoutRegistration.getTarget();
                        }
                        var anchorAsEvent = flyoutAnchor;
                        var currentElement = void 0;
                        if (anchorAsEvent && anchorAsEvent.target) {
                            currentElement = $(anchorAsEvent.target);
                        }
                        else {
                            currentElement = flyoutAnchor;
                        }
                        var currentElementRect = $dyn.util.elementRectangle(currentElement);
                        for (var j = flyoutOptions.scrollParents.length - 1; j >= 0; j--) {
                            var parentElementRect = $dyn.util.elementRectangle(flyoutOptions.scrollParents[j]);
                            if (!$dyn.util.isElementVisibleInParentContainer(currentElementRect, parentElementRect)) {
                                if (i > 0) {
                                    if (flyoutTarget) {
                                        flyoutTarget.click();
                                    }
                                    else if (flyoutOptions.show) {
                                        flyoutOptions.show(false);
                                    }
                                }
                                else {
                                    $(document.body).click();
                                }
                                break;
                            }
                        }
                        // tslint:disable-next-line:no-shadowed-variable
                        var flyout_2 = flyoutRegistration.flyout();
                        if (flyout_2) {
                            flyout_2.css("max-height", "");
                            flyout_2.css("max-width", "");
                            // Note IE needs these called in this order or it hits infinate loop in the events
                            // restore the scroll position of the flyout before resizing
                            flyout_2.scrollTop(flyout_2.scrollTop());
                            // Resize the flyout before repositioning it
                            $dyn.util.resizeFlyoutToScreen(flyout_2, flyoutAnchor, flyoutOptions.padding);
                            $dyn.util.position(flyoutOptions, flyout_2);
                        }
                    }
                };
                /**
                 * Gets the focus region of the given flyout
                 * @param flyout The registry info of the flyout whose focus region is to be found.
                 * @returns JQuery object wrapping the focus region of the flyout or null/undefined if none found
                 */
                // tslint:disable-next-line:no-shadowed-variable
                this.getFlyoutFocusRegion = function (flyout) {
                    var flyoutFocusRegion = flyout.focusRegion;
                    var flyoutTarget = flyout.target;
                    if (!flyoutTarget && flyout.getTarget) {
                        flyoutTarget = flyout.getTarget();
                    }
                    if (flyoutFocusRegion === undefined && flyoutTarget && flyoutTarget.length) {
                        // Resolve the focus region for this flyout
                        // For a root flyout, the focus region is determined by where its target belongs to
                        // For nested level flyouts, we look a level below and check if the target is contained inside that previous level flyout. If it is
                        // we consider this flyout to belong to the same focus region as its level below
                        flyoutFocusRegion = flyoutTarget.closest(".binding-focusRegion")[0];
                        if (!flyoutFocusRegion && _this.flyoutStack.length > 1) {
                            // Look through parent flyouts to get the focus region
                            for (var i = _this.flyoutStack.indexOf(flyout) - 1; i >= 0; i--) {
                                var flyoutRegistry = _this.flyoutStack[i];
                                if (flyoutRegistry) {
                                    var $flyoutElement = $dyn.value(flyoutRegistry.flyout);
                                    if ($flyoutElement && $.contains($flyoutElement[0], flyoutTarget[0])) {
                                        flyoutFocusRegion = flyoutRegistry.focusRegion;
                                        break;
                                    }
                                }
                            }
                        }
                        flyout.focusRegion = flyoutFocusRegion ? flyoutFocusRegion : null;
                    }
                    return flyoutFocusRegion;
                };
                /**
                 * Determines whether or not the flyout is currently in focus transfer mode and should not be closed by a click into the focus target.
                 * @param flyout The flyout on which to check focus transfer mode.
                 * @param event event triggering the function.
                 * @returns True if in focus transfer mode; otherwise, false.
                 */
                // tslint:disable-next-line:no-shadowed-variable
                this.isFlyoutInFocusTransferMode = function (flyout, event) {
                    if (flyout.options &&
                        flyout.options.highlyResponsive &&
                        flyout.options.focusTarget &&
                        !$dyn.value(flyout.options.takeFocus) &&
                        flyout.options.flyout &&
                        flyout.options.flyout.length === 1) {
                        // The flyout was initially opened with TakeFocus = False, such that focus should remain in the focusTarget hosting the flyout.
                        var $focusTarget = typeof (flyout.options.focusTarget) === "function" ? flyout.options.focusTarget() : flyout.options.focusTarget;
                        var flyoutElement = flyout.options.flyout[0];
                        var flyoutContext = $dyn.context(flyoutElement);
                        if ($focusTarget && $focusTarget.length && $focusTarget[0] === event.target && flyoutContext.takeFocusToggled) {
                            // The user had transferred focus into the flyout, causing TakeFocus to be true. The user is now clicking back into the focusTarget
                            // hosting the flyout, so we should not dismiss the flyout.
                            return true;
                        }
                    }
                    return false;
                };
                /**
                 * Event handler when mouse down occurs with flyouts open
                 * @param event The mouse down event
                 */
                this.mouseDownHandler = function (event) {
                    _this.mouseDownEvent = event;
                };
                /**
                 * Event handler for when the flyouts are clicked.
                 * @param event The click event
                 */
                this.bodyClickHandler = function (event) {
                    // Add mouseDown event so its' target can be used when determining if the event was within the flyout
                    event.mouseDownEvent = _this.mouseDownEvent;
                    _this.mouseDownEvent = null;
                    var topFlyout = null;
                    if ($dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                        topFlyout = $dyn.flyout.flyoutManager.getTopFlyout();
                    }
                    if (topFlyout) {
                        // compare focus region of click and topFlyout
                        // Flyouts are not dismissed if the body click originated from a different focus region than where the topFlyout belongs to
                        if (!$dyn.util.flyout.isClosableFocusRegion(event.target)) {
                            return;
                        }
                        if ($dyn.flyout.flyoutManager.isFlyoutInFocusTransferMode(topFlyout, event)) {
                            return;
                        }
                        // dont dismiss for SuperToolTips (class is qtip)
                        if ($(event.target).parents().hasClass("qtip")) {
                            return;
                        }
                        var topFlyoutTarget = topFlyout.target;
                        if (!topFlyoutTarget && topFlyout.getTarget) {
                            topFlyoutTarget = topFlyout.getTarget();
                        }
                        // If the click is not on the button that opened the topFlyout and there is an active topFlyout, and also they belong to same focus region
                        if (!topFlyoutTarget || !topFlyoutTarget[0] || topFlyoutTarget[0] !== event.target && !$.contains(topFlyoutTarget[0], event.target)) {
                            $dyn.util.flyout.clickHandler(event);
                            // If we have clicked a control on a form that is active, update that form's active control
                            var clickedControl = $dyn.context(event.target);
                            if (clickedControl && clickedControl.Root && clickedControl.Root.InternalFocusIn && $(event.target).is(":focusable")) {
                                clickedControl.Root.focusedControl = event.target;
                                clickedControl.Root.InternalFocusIn(clickedControl.element, clickedControl.Root.ActiveElement());
                            }
                        }
                    }
                };
                /**
                 * Gets the flyout registration object for the flyout given the formId (formID === flyout Id).
                 * @param formId The id of the form to find.
                 * @returns Array of flyout registration objects.
                 */
                this.findAllFlyoutsByFormId = function (formId) {
                    // tslint:disable-next-line:no-shadowed-variable
                    var flyoutsWithMatchingForm = _this.flyoutStack.filter(function (flyout) {
                        var flyoutElement = $dyn.value(flyout.flyout)[0];
                        var context = $dyn.context(flyoutElement);
                        return context && context.Id === formId;
                    });
                    return flyoutsWithMatchingForm;
                };
                /**
                 * Gets the flyout registration objects for all flyouts given
                 * the parent formId (parent formID === flyout-> Root.Id).
                 * @param parentFormId The id of the parnet form.
                 * @returns Array of flyout registration objects.
                 */
                this.findAllFlyoutsByParentFormId = function (parentFormId) {
                    // tslint:disable-next-line:no-shadowed-variable
                    var flyoutsWithMatchingForm = _this.flyoutStack.filter(function (flyout) {
                        var flyoutElement = $dyn.value(flyout.flyout)[0];
                        var context = $dyn.context(flyoutElement);
                        // If the flyouts root set and it the root the target parent form Id
                        return context && context.Root && context.Root.Id === parentFormId;
                    });
                    return flyoutsWithMatchingForm;
                };
                this.flyoutStack = [];
                this.mouseDownEvent = null;
            }
            /**
             * Maps the event object to a new object containing only the properties we care about.
             * @param mouseClickEvent The mouse click event object.
             * @returns Custom mouse click info.
             */
            FlyoutManager.prototype.getMouseClickInfo = function (mouseClickEvent) {
                var isRightClick = mouseClickEvent &&
                    mouseClickEvent.type === "click" &&
                    mouseClickEvent.which === 3;
                // Use the mouse down event so if the click orginated from within the flyout we do not close
                var intendedTarget = (mouseClickEvent.mouseDownEvent ? mouseClickEvent.mouseDownEvent.target : mouseClickEvent.target);
                var intendedX = mouseClickEvent.mouseDownEvent ? mouseClickEvent.mouseDownEvent.pageX : mouseClickEvent.pageX;
                var intendedY = mouseClickEvent.mouseDownEvent ? mouseClickEvent.mouseDownEvent.pageY : mouseClickEvent.pageY;
                return {
                    clickTarget: intendedTarget,
                    clickX: intendedX,
                    clickY: intendedY,
                    isRightClick: isRightClick,
                };
            };
            return FlyoutManager;
        }());
        /** The flyoutManager itself. This is a sigleton which should not be instantiated. */
        flyout_1.flyoutManager = new FlyoutManager();
    })(flyout = $dyn.flyout || ($dyn.flyout = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=flyoutManager.js.map
